import axios from 'axios'
import { Filter } from 'lucide-react'
import { useEffect, useState } from 'react'
import EsmaCard from './EsmaCard'

interface Esma {
  id: number
  name: string
  meaning: string
  eq_domain: string
  description: string
}

export default function EsmaList() {
  const [esmas, setEsmas] = useState<Esma[]>([])
  const [filteredEsmas, setFilteredEsmas] = useState<Esma[]>([])
  const [selectedDomain, setSelectedDomain] = useState<string>('all')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  // Tum Esmalari yukle
  useEffect(() => {
    const fetchEsmas = async () => {
      try {
        setLoading(true)
        const response = await axios.get<Esma[]>('http://localhost:8004/esmas')
        setEsmas(response.data)
        setFilteredEsmas(response.data)
        setError(null)
      } catch (err) {
        setError('Esma verileri yuklenemedi')
        console.error('Esma fetch error:', err)
      } finally {
        setLoading(false)
      }
    }

    void fetchEsmas()
  }, [])

  // Domain filtresi
  useEffect(() => {
    if (selectedDomain === 'all') {
      setFilteredEsmas(esmas)
    } else {
      setFilteredEsmas(esmas.filter(e => e.eq_domain === selectedDomain))
    }
  }, [selectedDomain, esmas])

  // Unique domain listesi
  const domains = ['all', ...Array.from(new Set(esmas.map(e => e.eq_domain)))]

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4"
               style={{ borderColor: 'var(--primary-color)' }} />
          <p style={{ color: 'var(--text-secondary)' }}>Yukleniyor...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="card">
        <div className="card-body p-6 text-center">
          <p style={{ color: 'var(--danger-color)' }}>{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Filtre */}
      <div className="card mb-6">
        <div className="card-body p-4">
          <div className="flex items-center gap-3">
            <Filter size={20} style={{ color: 'var(--text-secondary)' }} />
            <select
              value={selectedDomain}
              onChange={(e) => setSelectedDomain(e.target.value)}
              className="form-select flex-1"
              style={{
                background: 'var(--input-bg)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                padding: '8px 12px'
              }}
            >
              <option value="all">Tum Domainler ({esmas.length})</option>
              {domains.filter(d => d !== 'all').map(domain => (
                <option key={domain} value={domain}>
                  {domain} ({esmas.filter(e => e.eq_domain === domain).length})
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Esma grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredEsmas.map(esma => (
          <EsmaCard key={esma.id} esma={esma} />
        ))}
      </div>

      {/* Sonuc sayisi */}
      <div className="mt-6 text-center">
        <p style={{ color: 'var(--text-secondary)' }}>
          {filteredEsmas.length} Esma gosteriliyor
        </p>
      </div>
    </div>
  )
}
